import styled, { css } from 'styled-components';

export const ModuleStatusPopupContainer = styled.div`
  width: 200px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #272f3c;
  font-size: 20px;

  ${props => 
    css`
      left: ${props.xcoordinate - 25}px;
      top: ${props.ycoordinate - 25}px;
    `
  }
`

export const ModuleStatusPopupBox = styled.div`
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #fff;
  cursor: pointer;

  ${props => 
    props.status && 
      css`
        background: #274f3c;
      `
  }

  &:hover {
    background: #274f3c;
  }

  & > div.icon {
    flex: 1;

    & > img {
      height: 50px;
    }
  }
  & > div.name {
    flex: 1;
  }
`